// ContactModal.js
import React, { useState, useEffect } from 'react';

const ContactModal = ({ isOpen, onClose, phoneNumber, message, onConfirmSend }) => {
  const [toastVisible, setToastVisible] = useState(false);
  const [phoneSelected, setPhoneSelected] = useState(false);
  const [showConfirmButton, setShowConfirmButton] = useState(false);

  // Resetar estados ao fechar o modal ou ao carregar um novo contato
  useEffect(() => {
    if (isOpen) {
      setPhoneSelected(false);
      setShowConfirmButton(false);
    }
  }, [isOpen, phoneNumber]); // Adicionado phoneNumber para resetar ao mudar de contato

  if (!isOpen) return null;

  const copyToClipboard = (text) => {
    navigator.clipboard.writeText(text);
    showToast(`${text} copiado para a área de transferência!`);
  };

  const showToast = (message) => {
    setToastVisible(true);
    setTimeout(() => setToastVisible(false), 1000); // Toast desaparece após 1 segundo
  };

  const handlePhoneClick = () => {
    copyToClipboard(phoneNumber);
    setPhoneSelected(true);
    // Abre o aplicativo de SMS com o número e a mensagem pré-carregada
    window.location.href = `sms:${phoneNumber}?&body=${encodeURIComponent(message)}`;
    
    // Mostrar o botão "Confirmar Envio" após 3 segundos
    setTimeout(() => setShowConfirmButton(true), 3000);
  };

  return (
    <>
      <div className="fixed inset-0 bg-black bg-opacity-50 flex justify-center items-end">
        <div className="bg-white w-full max-w-md p-6 rounded-t-lg shadow-lg relative">
          <button
            className="absolute top-4 right-4 text-gray-400 hover:text-gray-600 text-sm rounded-lg"
            onClick={onClose}
          >
            ✕
          </button>
          <div className="mb-4 text-center">
            <div
              className={`border border-gray-300 p-3 rounded-lg text-gray-800 text-lg cursor-pointer ${phoneSelected ? 'line-through' : ''}`}
              onClick={handlePhoneClick}
            >
              {phoneNumber} {phoneSelected && '✔️'}
            </div>
          </div>
          {showConfirmButton && (
            <button
              className="bg-green-500 text-white w-full py-2 rounded-lg hover:bg-green-600"
              onClick={() => onConfirmSend(phoneNumber)}
            >
              Confirmar Envio
            </button>
          )}
        </div>
      </div>

      {/* Toast de confirmação de cópia */}
      {toastVisible && (
        <div className="fixed bottom-6 left-1/2 transform -translate-x-1/2 bg-black text-white py-2 px-4 rounded-lg shadow-lg opacity-90 transition-opacity duration-300">
          Copiado para a área de transferência!
        </div>
      )}
    </>
  );
};

export default ContactModal;
